import PhaserLifecyclePlugin from "./phaser-lifecycle-plugin";

export default PhaserLifecyclePlugin;
